export default __webpack_public_path__ + "static/media/star-2-1.c5214570.svg";